import OrderItemOnboarding from './order-item-onboarding';

export default OrderItemOnboarding;
